<template>
  <div class="container">
    <div class="legendNames"
         v-bind:style="{gridTemplateColumns: '0.5fr repeat(' + (2 * (colorLegendData.length - 1)) + ', 1fr) 0.5fr'}"
    >
          <span
            v-for="legend in colorLegendData"
            v-bind:key="legend.value+'-number'"
            v-bind:style="{backgroundColor: legend.value, opacity: legend.visibility ? 0.8 : 0.2,  border: legend.visibility ? 'black solid 1px' : ''}"
            v-on:click="$emit('filterChange', legend.key)"
            title="Click to toggle"
          >{{legend.label}}</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CategoricalLegend',
    props: [
      "colorLegendData",
    ],
  }
</script>
<style scoped>
  .container {
    grid-column: 1 / -1;
  }
  .legendNames span {
    grid-column-end: span 2;
  }

  .legendNames span.dash {
    grid-column-end: span 1;
    font-weight: bold;
  }

  .legendNames {
    display: grid;
    width: 100%;
    grid-gap: 2px;
    text-align: center;
    font-weight: bold;
    font-size: 0.8em;
    text-shadow: 1px 1px 1px #f8f6f6;
    margin-top: 7px;
  }

  .legendNames span {
    grid-column-end: span 2;
  }

</style>
